module.exports = __webpack_public_path__ + "static/media/childResidenceInfo.62af0716.png";